// vocabulary/history.ts
import { VocabPair } from './types';

export const history: VocabPair[] = [
  { word: "Democracy", definition: "Government by the people" },
  { word: "Revolution", definition: "Sudden complete change in government" },
  { word: "Constitution", definition: "Written plan for government" },
  { word: "Empire", definition: "Group of countries under one ruler" },
  { word: "Civilization", definition: "Advanced stage of human development" },
  { word: "Monarchy", definition: "Government ruled by a king or queen" },
  { word: "Renaissance", definition: "Period of renewed interest in art and learning" },
  { word: "Abolition", definition: "Act of ending something, like slavery" },
  { word: "Treaty", definition: "Formal agreement between countries" },
  { word: "Amendment", definition: "Change or addition to a document" },
  { word: "Colony", definition: "Territory controlled by another country" },
  { word: "Federation", definition: "Union of states under one government" },
  { word: "Dynasty", definition: "Series of rulers from same family" },
  { word: "Imperialism", definition: "Policy of extending a country's power" },
  { word: "Nationalism", definition: "Pride in and devotion to one's country" },
  { word: "Reformation", definition: "Religious movement for church reform" },
];